// App.js
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/albina/Home';
import HomeFF from './pages/alfaroojfresh/Home';

import Suppliers from './pages/albina/Suppliers';
import SuppliersFF from './pages/alfaroojfresh/Suppliers';

import PurchaseOrders from './pages/albina/PurchaseOrders';
import PurchaseOrdersFF from './pages/alfaroojfresh/PurchaseOrders';

import Login from './pages/Login';
import { PurchaseOrdersProvider } from './contexts/albina/PurchaseOrdersContext';
import { PurchaseOrdersProvider as PurchaseOrdersProviderFF } from './contexts/alfaroojfresh/PurchaseOrdersContext';
import Footer from './components/Footer';
import './App.css';
import PurchasesByGoodPage from './pages/albina/PurchasesByGood';
import PurchasesByGoodPageFF from './pages/alfaroojfresh/PurchasesByGood';

import PurchasesByUnitPage from './pages/albina/PurchasesByUnit';
import PurchasesByUnitPageFF from './pages/alfaroojfresh/PurchasesByUnit';

import BusinessSummary from './components/albina/BusinessSummary';
import BusinessSummaryFF from './components/alfaroojfresh/BusinessSummary';

import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './components/Sidebar';
import Logo from './assets/logo/logo.png';
import InventoryPage from './pages/alfaroojfresh/InventoryPage';
import { CacheProvider } from './hooks/Cachecontext';

// ─── Must match the constants in Sidebar.jsx ─────────────────────────────────
const SIDEBAR_FULL = 260;
const SIDEBAR_MINI = 68;

// ─── Auth helpers ─────────────────────────────────────────────────────────────
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const email = sessionStorage.getItem('email');
  return Boolean(token && email);
};

const getHomeRoute = (email) => {
  if (email === 'Albina@booncoffee.com') return '/albina/home';
  if (email === 'odoo-admin@alfaroojfresh.com') return '/alfaroojfresh/home';
  return '/albina/home';
};

// ─── DashboardLayout ──────────────────────────────────────────────────────────
const DashboardLayout = ({ children }) => {
  const theme     = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const contentWidth = isDesktop
    ? `calc(100% - ${sidebarOpen ? SIDEBAR_FULL : SIDEBAR_MINI}px)`
    : '100%';

  const userEmail = sessionStorage.getItem('email') ?? '—';
  const avatarLetter = userEmail !== '—' ? userEmail[0].toUpperCase() : '?';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          width: contentWidth,
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        {/* Top Bar */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            backgroundColor: '#1e3a8a',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          <img alt="logo" width={110} src={Logo} />

          {/* User email badge */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: '999px',
              padding: '5px 14px 5px 8px',
            }}
          >
            {/* Avatar circle with first letter of email */}
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                backgroundColor: '#facc15',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '13px',
                color: '#1e3a8a',
                flexShrink: 0,
              }}
            >
              {avatarLetter}
            </Box>

            <Box
              sx={{
                fontSize: '13px',
                color: 'rgba(255,255,255,0.9)',
                fontWeight: 500,
                maxWidth: { xs: '120px', sm: '240px' },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {userEmail}
            </Box>
          </Box>
        </Box>

        <Box component="main" sx={{ padding: '20px', flexGrow: 1 }}>
          {children}
        </Box>

        <Footer />
      </Box>
    </Box>
  );
};

// ─── Public route ─────────────────────────────────────────────────────────────
const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    const email = sessionStorage.getItem('email') ?? '';
    return <Navigate to={getHomeRoute(email)} replace />;
  }
  return (
    <div
      className="login-layout"
      style={{ width: '100%', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {children}
    </div>
  );
};

// ─── Private route ────────────────────────────────────────────────────────────
const PrivateRoute = ({ children }) => {
  if (!isAuthenticated()) return <Navigate to="/" replace />;
  return children;
};

// ─── App ──────────────────────────────────────────────────────────────────────
function App() {
 console.log({
    Home,
    HomeFF,
    Suppliers,
    SuppliersFF,
    PurchaseOrders,
    PurchaseOrdersFF,
    BusinessSummary,
    BusinessSummaryFF,
    InventoryPage,
    Sidebar,
    Footer,
    Login,
  });
  return (
    <CacheProvider>
      <PurchaseOrdersProvider>
        <PurchaseOrdersProviderFF>
          <Router>
            <Routes>
              {/* Login */}
              <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />

              {/* Catch-all */}
              <Route path="*" element={<Navigate to="/" replace />} />

              {/* ─── Albina ─── */}
              <Route path="/albina/home"            element={<PrivateRoute><DashboardLayout><Home /></DashboardLayout></PrivateRoute>} />
              <Route path="/albina/suppliers"        element={<PrivateRoute><DashboardLayout><Suppliers /></DashboardLayout></PrivateRoute>} />
              <Route path="/albina/purchase-orders"  element={<PrivateRoute><DashboardLayout><PurchaseOrders /></DashboardLayout></PrivateRoute>} />
              <Route path="/albina/goods"            element={<PrivateRoute><DashboardLayout><PurchasesByGoodPage /></DashboardLayout></PrivateRoute>} />
              <Route path="/albina/unit"             element={<PrivateRoute><DashboardLayout><PurchasesByUnitPage /></DashboardLayout></PrivateRoute>} />
              <Route path="/albina/business-summary" element={<PrivateRoute><DashboardLayout><BusinessSummary /></DashboardLayout></PrivateRoute>} />

              {/* ─── Al Farooj Fresh ─── */}
              <Route path="/alfaroojfresh/home"             element={<PrivateRoute><DashboardLayout><HomeFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/suppliers"         element={<PrivateRoute><DashboardLayout><SuppliersFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/purchase-orders"   element={<PrivateRoute><DashboardLayout><PurchaseOrdersFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/goods"             element={<PrivateRoute><DashboardLayout><PurchasesByGoodPageFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/unit"              element={<PrivateRoute><DashboardLayout><PurchasesByUnitPageFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/business-summary"  element={<PrivateRoute><DashboardLayout><BusinessSummaryFF /></DashboardLayout></PrivateRoute>} />
              <Route path="/alfaroojfresh/inventory-summary" element={<PrivateRoute><DashboardLayout><InventoryPage /></DashboardLayout></PrivateRoute>} />
            </Routes>
          </Router>
        </PurchaseOrdersProviderFF>
      </PurchaseOrdersProvider>
    </CacheProvider>
  );
  
}

export default App;